var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrass29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dd463;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.8,711.68c23-43.11,86.1-58.24,126.13-30.23-28.31-39.78-57.36-81.28-66.12-129.31s9-104.62,53.23-125.25c39.14-18.25,87.32-3.05,119.61,25.62S712.76,521,731.81,559.72c-4.28-36.8,15.19-75.28,47.38-93.63s75.22-15.51,104.72,6.92c-3.88-34.92-6.61-70.45-.36-105s22.39-68.53,50.28-89.91c51.53-39.48,129.36-24.65,179.81,16.2s80,101.47,107.94,160.06A2018.65,2018.65,0,0,0,642.64,748.56C593,784.92,547.91,828.51,498.09,864,447.09,816.87,409.38,785.38,427.8,711.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass29);
export default __webpack_public_path__ + "static/media/grass-29.60cdaeca89eb389e9029d0d3f89a3f7e.svg";
export { ForwardRef as ReactComponent };